export interface Chat {
    opened?: boolean;
    loaded?: boolean;
    active?: boolean;
    configuration?: ChatConfig;
}

export interface ChatConfig {
    url?: string;
}

export type ChatWeekDays = 'friday' | 'monday' | 'saturday' | 'sunday' | 'thursday' | 'tuesday' | 'wednesday';

export enum ChatType {
    HUBTYPE = 'HUBTYPE',
    URLCHAT = 'URLCHAT',
    KAKAOTALK = 'KAKAOTALK',
    MOCHACHAT = 'MOCHACHAT',
    STYLE_ADVISOR = 'STYLE_ADVISOR',
    LIVE_HELP_WINDOW = 'LIVE_HELP_WINDOW',
}

export interface ChatDaySchedule {
    fromTime: string; // 'HHmmss'
    toTime: string; // 'HHmmss'
}

export interface ChatWeekSchedule {
    openHours: ChatDaySchedule[];
}

export type ChatCmsWeekSchedule = Record<Partial<ChatWeekDays>, ChatDaySchedule[]>;

export interface ChatSchedule {
    cms: false;
    isOutOfService: boolean;
    weeklySchedule: ChatWeekSchedule[];
    outOfServiceMessage?: string;
    outOfScheduleMessage?: string;
}

export interface ChatCmsSchedule {
    cms: true;
    isOutOfService: boolean;
    weeklySchedule: ChatCmsWeekSchedule[];
    outOfServiceMessage?: string;
    outOfScheduleMessage?: string;
}
